export default {

  // 新增提货
  insertYcDelivery: '/ygsjzs/ycDelivery/insertYcDelivery',
  // 修改提货
  updateYcDelivery: '/ygsjzs/ycDelivery/updateYcDelivery',

  // 删除提货
  deleteYcDelivery: '/ygsjzs/ycDelivery/deleteYcDelivery',
  // 查询提货列表
  selectYcDeliveryByList: '/ygsjzs/ycDelivery/selectYcDeliveryByList',
  // 详情
  selectYcDeliveryByDeliveryId: '/ygsjzs/ycDelivery/selectYcDeliveryByDeliveryId'
}
